/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import md5 from 'blueimp-md5';

// Proto: auth.User.
export default class User extends Model {
  declare [Type]: 'user';

  @attr('string', { defaultValue: '' })
  declare username: string;

  @attr('string')
  declare schoolId: string | undefined;

  @attr('string', { defaultValue: '' })
  declare personId: string;

  @attr()
  declare roles: string[] | undefined;

  @computed('roles')
  get primaryRole() {
    if (isEmpty(this.roles)) {
      return 'NONE';
    }

    return this.roles![0];
  }

  @attr('string', { defaultValue: '' })
  declare password: string; // Should never be set, except when creating new users.

  @computed('id')
  get image() {
    return `https://gravatar.com/avatar/${md5(this.id!)}?d=monsterid&f=y`;
  }

  @alias('username')
  declare bannerText: string;
}
